import { useMemo } from 'react'
import { usePlatform } from '@/hooks/usePlatform'
import { useAuth } from '@/hooks/useAuth'
import { getAdapter } from '@/adapters/registry'
import type { AdapterSession } from '@/adapters/types'

export function useAdapter() {
    const { selectedProtocol } = usePlatform()
    const { session, mastodonSession, pixelfedSession, nostrSession } = useAuth()

    const adapter = useMemo(() => getAdapter(selectedProtocol), [selectedProtocol])

    const adapterSession: AdapterSession | null = useMemo(() => {
        switch (selectedProtocol) {
            case 'bluesky':
                return session ?? null
            case 'mastodon':
                return mastodonSession ?? null
            case 'pixelfed':
                return pixelfedSession ?? null
            case 'nostr':
                return nostrSession ?? null
            default:
                return null
        }
    }, [selectedProtocol, session, mastodonSession, pixelfedSession, nostrSession])

    return { adapter, session: adapterSession, platform: selectedProtocol }
}
